import {
  getFullNameReversed,
  UUID,
  AssigneesProjectResponseType,
} from '@builddocs/data-management'
import { Box, Typography } from '@mui/material'

type OwnProps = {
  kind: string
  assignees: AssigneesProjectResponseType[]
  selected: UUID[]
  selectedKey: string
  title: string
  onChangeKey: (key: string) => void
}

const TypeRepresentative = ({
  kind,
  selected,
  selectedKey,
  title,
  onChangeKey,
  assignees,
}: OwnProps) => {
  const isSelected = selectedKey === kind

  return (
    <Box
      sx={{
        p: 1,
        backgroundColor: isSelected ? '#e7f2f8' : 'white',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#e7f2f8',
        },
        borderRadius: 2.5,
      }}
      onClick={() => onChangeKey(kind)}
    >
      <Typography gutterBottom fontWeight="bold" variant="subtitle2">
        {title}
      </Typography>
      {selected.length === 0 && (
        <Typography color="text.secondary" variant="body2">
          Добавьте представителя
        </Typography>
      )}

      {assignees.length > 0 &&
        selected.map(id => (
          <Typography key={id}>
            {`• ${getFullNameReversed(
              assignees.find(user => user.employmentId === id)!,
            )}`}
          </Typography>
        ))}
    </Box>
  )
}

export default TypeRepresentative
